import moment from "moment";
import React from "react";
import bus from "../images/iconType/bus.png";
import indoor from "../images/iconType/indoor.png";
import outdoor from "../images/iconType/outdoor.png";
import pos from "../images/iconType/pos.png";
import circuitIndoor from "../images/iconType/circuit_indoor.png";
import circuitOutdoor from "../images/iconType/circuit_outdoor.png";
import taxi from "../images/iconType/taxi.png";
import busWhitelabel from "../images/iconTypeWhiteLabel/bus.png";
import indoorWhitelabel from "../images/iconTypeWhiteLabel/indoor.png";
import outdoorWhitelabel from "../images/iconTypeWhiteLabel/outdoor.png";
import posWhitelabel from "../images/iconTypeWhiteLabel/pos.png";
import circuitIndoorWhitelabel from "../images/iconTypeWhiteLabel/circuit_indoor.png";
import circuitOutdoorWhitelabel from "../images/iconTypeWhiteLabel/circuit_outdoor.png";
import taxiWhitelabel from "../images/iconTypeWhiteLabel/taxi.png";
import contains from "ramda/src/contains";

import * as markersLatinad from '../themes/makersLatinad';
import * as markersWhiteLabel from '../themes/makersWhiteLabel';
import { getDomain } from "./utils";
import { impressions } from "../newSrc/features/campaignManager/services/investmentCalculations";
const domain = getDomain(window.location.hostname);
const markers = domain === "latinad" ? markersLatinad : markersWhiteLabel;

/**
 * [
 *  {
 *    lat_ne: number,
 *    lng_ne: number,
 *    lng_sw: number,
 *    lat_sw: number
 *  }
 * ]
 */

export function getBounds(campaignZonesLatLng) {
  const bounds = campaignZonesLatLng.reduce((acc, coord) => {
    acc.maxLat = Math.max(acc.maxLat, coord.lat_ne);
    acc.minLat = Math.min(acc.minLat, coord.lat_sw);
    acc.maxLng = Math.max(acc.maxLng, coord.lng_ne);
    acc.minLng = Math.min(acc.minLng, coord.lng_sw);
    return acc;
  }, { maxLat: -90, maxLng: -180, minLng: 180, minLat: 90 });

  return {
    lat_ne: bounds.maxLat,
    lng_ne: bounds.maxLng,
    lng_sw: bounds.minLng,
    lat_sw: bounds.minLat
  };
}

export function convertBounds(viewport) {
  return {
    lat_ne: viewport.getNorthEast().lat(),
    lng_ne: viewport.getNorthEast().lng(),
    lng_sw: viewport.getSouthWest().lng(),
    lat_sw: viewport.getSouthWest().lat()
  };
}

// Longest side of a { north, south, east, west } box in km, using the same
// approximation as the backend map mode (1° ≈ 111 km, longitude corrected by
// the mid latitude). Returns 0 when the bounds are unknown.
export function getBoundsSideKm(bounds) {
  if (!bounds) return 0;
  const north = parseFloat(bounds.north);
  const south = parseFloat(bounds.south);
  const east = parseFloat(bounds.east);
  const west = parseFloat(bounds.west);
  if ([north, south, east, west].some(isNaN)) return 0;
  const latKm = Math.abs(north - south) * 111;
  const lngKm = Math.abs(east - west) * 111 * Math.cos((((north + south) / 2) * Math.PI) / 180);
  return Math.max(latKm, lngKm);
}

export function getLocationType(type, t) {
  if (type === "outdoor") {
    return "Outdoor";
  }
  if (type === "indoor") {
    return "Indoor";
  }
  if (type === "buses") {
    return t('Mobile');
  }
  if (type === "pos") {
    return t('Point of sale');
  }
};

export function getIconType(locationType, displayType, onCart, isPin) {
  isPin = isPin == 'isPin' || false;

  if (locationType === "buses") {
    if(!isPin) return domain === "latinad" ? bus : busWhitelabel;

    if (onCart) {
      return domain === "latinad" ? markers.markerBusOnCart : markers.markerBusOnCart();
    } else {
      return domain === "latinad" ? markers.markerBus : markers.markerBus();
    }
  } else if (locationType === "indoor" && displayType === "normal") {
    if(!isPin) return domain === "latinad" ? indoor : indoorWhitelabel;

    if (onCart) {
      return domain === "latinad" ? markers.markerIndoorOnCart : markers.markerIndoorOnCart();
    } else {
      return domain === "latinad" ? markers.markerIndoor : markers.markerIndoor();
    }
  } else if (locationType === "indoor" && displayType === "main") {
    if(!isPin) return domain === "latinad" ? circuitIndoor : circuitIndoorWhitelabel;

    if (onCart) {
      return domain === "latinad" ? markers.markerCircuitIndoorOnCart : markers.markerCircuitIndoorOnCart();
    } else {
      return domain === "latinad" ? markers.markerCircuitIndoor : markers.markerCircuitIndoor();
    }
  } else if (locationType === "outdoor" && displayType === "normal") {
    if(!isPin) return domain === "latinad" ? outdoor : outdoorWhitelabel;

    if (onCart) {
      return domain === "latinad" ? markers.markerOutdoorOnCart : markers.markerOutdoorOnCart();
    } else {
      return domain === "latinad" ? markers.markerOutdoor : markers.markerOutdoor();
    }
  } else if (locationType === "outdoor" && displayType === "main") {
    if(!isPin) return domain === "latinad" ? circuitOutdoor : circuitOutdoorWhitelabel;

    if (onCart) {
      return domain === "latinad" ? markers.markerCircuitOutdoorOnCart : markers.markerCircuitOutdoorOnCart();
    } else {
      return domain === "latinad" ? markers.markerCircuitOutdoor : markers.markerCircuitOutdoor();
    }
  } else if (locationType === "pos") {
    if(!isPin) return domain === "latinad" ? pos : posWhitelabel;

    if (onCart) {
      return domain === "latinad" ? markers.markerPosOnCart : markers.markerPosOnCart();
    } else {
      return domain === "latinad" ? markers.markerPos : markers.markerPos();
    }
  } else if (locationType === "taxi") {
    if(!isPin) return domain === "latinad" ? taxi : taxiWhitelabel;

    if (onCart) {
      return domain === "latinad" ? markers.markerTaxiOnCart : markers.markerTaxiOnCart();
    } else {
      return domain === "latinad" ? markers.markerTaxi : markers.markerTaxi();
    }
  } else {
    if (onCart) {
      return domain === "latinad" ? markers.markerLatinadOnCart : markers.markerOnCart();
    } else {
      return domain === "latinad" ? markers.markerLatinad : markers.marker();
    }
  }
}


export function adaptParams(params) {
  const newParams = {};

  if (params.date_from) newParams.date_from = params.date_from;
  if (params.date_to) newParams.date_to = params.date_to;
  if (params.lat_ne) newParams.lat_ne = parseFloat(params.lat_ne);
  if (params.lat_sw) newParams.lat_sw = parseFloat(params.lat_sw);
  if (params.lng_ne) newParams.lng_ne = parseFloat(params.lng_ne);
  if (params.lng_sw) newParams.lng_sw = parseFloat(params.lng_sw);
  if (params.shows_per_day_min) newParams.shows_per_day_min = parseInt(params.shows_per_day_min, 10);
  if (params.location_type) newParams.location_type = params.location_type;
  if (params.location_sub_type) newParams.location_sub_type = params.location_sub_type;
  if (params.size_type) newParams.size_type = params.size_type;
  if (params.page) newParams.page = parseInt(params.page, 10);
  if (params.currency) newParams.currency = params.currency;
  if (params.external_dsp_id) newParams.external_dsp_id = params.external_dsp_id;
  if (params.is_guaranteed) newParams.isGuaranteed = params.is_guaranteed === '1';
  if (params.programmatic) newParams.programmatic = params.programmatic === 'true' ? 'programmatic' : 'traditional';

  return newParams;
}

export function updateParams(oldParams, newParams) {
  return JSON.parse(JSON.stringify(Object.assign({}, oldParams, newParams)));
}

export function getDisplayingLocation(locations, translate) {
  if (locations.length === 0 || locations.length === 3) return translate('All');
  const showingDisplay = [];
  if (locations.includes("outdoor")) showingDisplay.push("Outdoor");
  if (locations.includes("indoor")) showingDisplay.push("Indoor");
  if (locations.includes("buses")) showingDisplay.push(translate('Mobile'));
  if (locations.includes("pos")) showingDisplay.push(translate('Point of sale'));

  return showingDisplay.join(", ");
}

export function getDisplayingSizes(sizes, translate) {
  if (sizes.length === 0 || sizes.length === 4) return translate('All');
  const showingDisplay = [];
  if (sizes.includes("small")) showingDisplay.push(translate('Small'));
  if (sizes.includes("medium")) showingDisplay.push(translate('Medium'));
  if (sizes.includes("big")) showingDisplay.push(translate('Big'));
  if (sizes.includes("giant")) showingDisplay.push(translate('Giant'));

  return showingDisplay.join(", ");
}

export function getAspectRatio(w, h) {
  const n = gcd(w, h);
  return `${w / n}:${h / n}`;
}

export function getSimilarAspectRatio(w, h, translate) {
  const n = gcd(w, h);
  if (((w/n)/(h/n)) === 1 ) {
    return translate('Square')
  } else if (((w/n)/(h/n)) < 1 ) {
    return translate('Vertical')
  } else if (((w/n)/(h/n)) > 1 && ((w/n)/(h/n)) < 2) {
    return translate('Horizontal')
  } else if (((w/n)/(h/n)) >= 2) {
    return translate('Super horizontal')
  }
}

export function getValidationError(errors, translate) {
  let e;
  if (!Array.isArray(errors)) {
    e = [errors];
  } else {
    e = errors;
  }

  if (e[0].errors && e[0].errors.username) {
    if (e[0].errors.username[0].includes("The username has already been taken.")) {
      return translate('The email entered already exists');
    }
  }
  if (e[0].errors && e[0].errors.email) {
    if (e[0].errors.email[0].includes("The email has already been taken.")) {
      return translate('The email entered already exists');
    }
    if (e[0].errors.email[0].includes("The email must be a valid email address.")) {
      return translate('Enter a valid email');
    }
  }
  if (e[0].errors && e[0].errors.first_name) {
    if (e[0].errors.first_name[0].includes("The first name may not be greater than 255 characters.")) {
      return translate('The name must be less than 255 characters.');
    }
  }
  if (e[0].errors && e[0].errors.last_name) {
    if (e[0].errors.last_name[0].includes("The last name may not be greater than 255 characters.")) {
      return translate('The last name must be less than 255 characters.');
    }
  }
  if (e[0].errors && e[0].errors.company_name) {
    if (e[0].errors.company_name[0].includes("The company name has already been taken.")) {
      return translate('The company name already exists. Please enter another.');
    }
  }
  if (e[0].errors && e[0].errors.two_factor_code) {
    if (e[0].errors.two_factor_code[0].includes("The two factor code must be 6 digits.")) {
      return translate('The code must have 6 digits');
    }
  }

  if (e[0].message.includes("Invalid credentials.")) {
    return translate('Incorrect username or password');
  }
  if (e[0].message.includes("Validation errors.")) {
    return translate('Fill in all fields');
  }
  if (e[0].message.includes("Mail not found on our database.")) {
    return translate('We cant find that email in our database, try another one.');
  }
  if (e[0].message.includes("Invalid code 2FA")) {
    return translate('Incorrect security code');
  }
  if (e[0].message.includes("User's account is not verified")) {
    return translate("Your account is not verified");
  }
  if (e[0].message.includes("No result for this model.")) {
    return translate('We cant find that email in our database, try another one.');
  }
  if (e[0].message.includes("The user is already verified.")) {
    return translate('This account has already been verified.');
  }
  if (e[0].message.includes("Too Many Attempts.")) {
    return translate('Too many attempts');
  }
  if (e[0].message.includes("User's account is not activated") || e[0].message.includes("User deactivated")) {
    return translate('Account is not activated');
  }
  if (e[0].message.includes("Password changed")) {
    return translate('Password changed');
  }

  return translate('Unexpected error');
}

export function getDatesRange(date_from, date_to) {
  let from, to;
  if (!date_from && !date_to) {
    from = moment().add(1, "days");
    to = moment().add(30, "day");
  } else if (!date_to) {
    from = date_from;
    to = moment(date_from).add(30, "days");
  } else if (!date_from) {
    from = moment(date_to).subtract(30, "days");
    if (from.isBefore(moment())) from = moment().add(1, "days");
    if (from.isAfter(date_to)) from = date_to;
    to = date_to;
  } else {
    from = date_from;
    to = date_to;
  }

  return {
    date_from: from.format("YYYY-MM-DD"),
    date_to: to.format("YYYY-MM-DD")
  };
}
export function getWorkingHoursList(t, displayHoursList, workingHoursList){
  for (var i = 0; i < 7; i++) {
    if (displayHoursList.find(wh => wh.day_of_week === i)) {
      const arrayHours = displayHoursList.filter(wh => wh.day_of_week === i);
      if (i === 0) {
        for (var j = 0; j < arrayHours.length; j++) {
          if (arrayHours[j].start_time === '00:00:00' && arrayHours[j].end_time === '00:00:00') {
            workingHoursList.push(
              <li key={j}>
                <span className="primary">{t('Sun')}: {t('Off')}</span><br />
              </li>
            );
          } else if (j === 0) {
            workingHoursList.push(
              <li key={j+'day'}>
                <span className="primary">{t('Sun')}:</span><br/>
              </li>
            );
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}> {arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          } else {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}> {arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          }
        }
      }
      if (i === 1) {
        for (var j = 0; j < arrayHours.length; j++) {
          if (arrayHours[j].start_time === '00:00:00' && arrayHours[j].end_time === '00:00:00') {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" >{t('Mon')}: {t('Off')}</span><br />
              </li>
            );
          } else if (j === 0) {
            workingHoursList.push(
              <li key={j+'day'}>
                <span className="primary" >{t('Mon')}:</span><br/>
              </li>
            );
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          } else {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          }
        }
      }
      if (i === 2) {
        for (var j = 0; j < arrayHours.length; j++) {
          if (arrayHours[j].start_time === '00:00:00' && arrayHours[j].end_time === '00:00:00') {
            workingHoursList.push(
              <li key={j}>
                <span className="primary">{t('Tue')}: {t('Off')}</span><br />
              </li>
            );
          } else if (j === 0) {
            workingHoursList.push(
              <li key={j+'day'}>
                <span className="primary">{t('Tue')}:</span><br />
              </li>
            );
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          } else {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          }
        }
      }
      if (i === 3) {
        for (var j = 0; j < arrayHours.length; j++) {
          if (arrayHours[j].start_time === '00:00:00' && arrayHours[j].end_time === '00:00:00') {
            workingHoursList.push(
              <li key={j}>
              <span className="primary">{t('Wed')}: {t('Off')}</span><br />
              </li>
            );
          } else if (j === 0) {
            workingHoursList.push(
              <li key={j+'day'}>
                <span className="primary">{t('Wed')}:</span><br />
              </li>
            );
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          } else {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          }
        }
      }
      if (i === 4) {
        for (var j = 0; j < arrayHours.length; j++) {
          if (arrayHours[j].start_time === '00:00:00' && arrayHours[j].end_time === '00:00:00') {
            workingHoursList.push(
              <li key={j}>
                <span className="primary">{t('Thu')}: {t('Off')}</span><br />
              </li>
            );
          } else if (j === 0) {
            workingHoursList.push(
              <li key={j+'day'}>
                <span className="primary">{t('Thu')}:</span><br />
              </li>
            );
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          } else {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "27px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          }
        }
      }
      if (i === 5) {
        for (var j = 0; j < arrayHours.length; j++) {
          if (arrayHours[j].start_time === '00:00:00' && arrayHours[j].end_time === '00:00:00') {
            workingHoursList.push(
              <li key={j}>
              <span className="primary">{t('Fri')}: {t('Off')}</span><br />
              </li>
            );
          } else if (j === 0) {
            workingHoursList.push(
              <li key={j+'day'}>
                <span className="primary">{t('Fri')}:</span><br />
              </li>
            );
            workingHoursList.push(
              <li key={j}>
              <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          } else {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "28px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          }
        }
      }
      if (i === 6) {
        for (var j = 0; j < arrayHours.length; j++) {
          if (arrayHours[j].start_time === '00:00:00' && arrayHours[j].end_time === '00:00:00') {
            workingHoursList.push(
              <li key={j}>
              <span className="primary">{t('Sat')}: {t('Off')}</span><br />
              </li>
            );
          } else if (j === 0) {
            workingHoursList.push(
              <li key={j+'day'}>
                <span className="primary">{t('Sat')}:</span><br />
              </li>
            );
            workingHoursList.push(
              <li key={j}>
              <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          } else {
            workingHoursList.push(
              <li key={j}>
                <span className="primary" style={{marginLeft: "30px"}}>{arrayHours[j].start_time.slice(0, -3)}hs - {arrayHours[j].end_time.slice(0, -3)}hs</span><br />
              </li>
            );
          }
        }
      }
    }
    else {
      if (i === 0) {
        workingHoursList.push(
          <li style={{marginBottom: "3px", marginTop:"2px"}}>
          <span className="primary">{t('Sun')}: {t('All day')}</span><br />
          </li>
        )
      } else if (i === 1) {
        workingHoursList.push(
          <li style={{marginBottom: "3px", marginTop:"2px"}}>
          <span className="primary">{t('Mon')}: {t('All day')}</span><br />
          </li>
        )
      } else if (i === 2) {
        workingHoursList.push(
          <li style={{marginBottom: "3px", marginTop:"2px"}}>
          <span className="primary">{t('Tue')}: {t('All day')}</span><br />
          </li>
        )
      } else if (i === 3) {
        workingHoursList.push(
          <li style={{marginBottom: "3px", marginTop:"2px"}}>
          <span className="primary">{t('Wed')}: {t('All day')}</span><br />
          </li>
        )
      } else if (i === 4) {
        workingHoursList.push(
          <li style={{marginBottom: "3px", marginTop:"2px"}}>
          <span className="primary">{t('Thu')}: {t('All day')}</span><br />
          </li>
        )
      } else if (i === 5) {
        workingHoursList.push(
          <li style={{marginBottom: "3px", marginTop:"2px"}}>
          <span className="primary">{t('Fri')}: {t('All day')}</span><br />
          </li>
        )
      } else if (i === 6) {
        workingHoursList.push(
          <li style={{marginBottom: "3px", marginTop:"2px"}}>
          <span className="primary">{t('Sat')}: {t('All day')}</span><br />
          </li>
        )
      }
    }
  }
  return workingHoursList
}


export function getDayOfWeekDisplayWork(workingHours, date_from, date_to) {
    let listDays = [];
    let count = 0
    workingHours.forEach((workingHour) => {
        // add day that not count, when end_time and start_time is 00:00:00 the screem is down
        if (workingHour['start_time'] == '00:00:00' && workingHour['end_time'] == '00:00:00') {
            listDays.push(workingHour.day_of_week)
        }
    });
    for (var dateToEval = moment(date_from); moment(date_to).diff(dateToEval, 'days') >= 0; dateToEval.add(1, 'days')) {
      if (listDays.find(element => element == dateToEval.day()) == undefined){
        count ++
      }
    }
    return count;
}

// Flatten the displaysMap response into a single list of display ids.
// In cluster mode each entry exposes an `ids` array; in detail mode each
// entry IS the display, so we read its `id`.
export function getDisplaysIdsFromMap(displaysMap, displaysMapMode) {
  if (displaysMapMode === "cluster") {
    return (displaysMap || []).reduce(
      (acc, cluster) => acc.concat(cluster.ids || []),
      [],
    );
  }
  return displaysMap.map((display) => display.id);
}

export function getTotalPice(listCart, date_from, date_to){
    return (
      listCart.reduce((acc, display) => {
        return acc + display.price_per_day *
        getDayOfWeekDisplayWork(display.working_hours, date_from, date_to);
      }, 0) * 100
    ) / 100
}


// Cost per impact
export function getCPM(campaingPrice, total_impacts) {
    if(total_impacts==0) return 0
    let CPM = (1000 * campaingPrice) / total_impacts;
    CPM = CPM.toFixed(2);
    return CPM
}

export function getCpmByStatusCampaign( editCampaignActive, currentCampaign, display ) {
  if( editCampaignActive && currentCampaign && currentCampaign.payment_status === 'approved' ) {
    const contentDisply = currentCampaign.contents_displays.find(item => item.display_id === display.id && item.cpm !== 0);
    if (contentDisply && contentDisply.cpm) return contentDisply.cpm
  }
  return display.smart_campaign_cpm
}

/**
 * @param {boolean} editCampaignActive
 * @param {Object} currentCampaign
 * @param {Object} display
 * @returns {number}
 */
export function getMultiplyByStatus( editCampaignActive, currentCampaign, display ) {
  if( editCampaignActive && currentCampaign && currentCampaign.payment_status === 'approved' ) {
    const contentDisplay = (currentCampaign.contents_displays || []).find(
      item => item.display_id === display.id && Number(item.multiplier) > 0
    )
    if (contentDisplay && Number(contentDisplay.multiplier)) return Number(contentDisplay.multiplier)
  }
  if (display && Number(display.multiplier) > 0) return Number(display.multiplier)
  return impressions.getMultiplyFromPrices(display) || 1
}

/**
 * @param {boolean} editCampaignActive
 * @param {Object} currentCampaign
 * @param {Object} display
 * @returns {number}
 */
export function getCpmiByStatusCampaign( editCampaignActive, currentCampaign, display ) {
  const multiplier = getMultiplyByStatus(editCampaignActive, currentCampaign, display)

  if( editCampaignActive && currentCampaign && currentCampaign.payment_status === 'approved' ) {
    const contentDisplay = (currentCampaign.contents_displays || []).find(
      item => item.display_id === display.id && (item.cpmi > 0 || item.cpm > 0)
    )
    if (contentDisplay && contentDisplay.cpmi > 0) return contentDisplay.cpmi
    if (contentDisplay && contentDisplay.cpm > 0) return contentDisplay.cpm / multiplier
  }

  if (display.cpmi > 0) return display.cpmi
  return display.smart_campaign_cpm / multiplier
}

// Check if item is in SUSPENDED state (subsidized with promised_shows === 0)
export const contentDisplayIsSuspended = (item) => item.subsidized_price && item.promised_shows === 0;

// Function to get the amount of audience for a relation of display or displays
export function getAmountAudienceDisplay(audience, displayId, isImpacts = false) {
  if (!audience || !audience.displays_with_audience) return 0;

  const totalAudience = audience.displays_with_audience
  .filter(element => element.id === displayId)
  .reduce((totals, element) => {
    totals.audience += element.audience;
    totals.impacts += element.impacts;
    return totals;
   }, { audience: 0, impacts: 0 });

  return isImpacts ? (totalAudience && totalAudience.impacts ? totalAudience.impacts :0 ) :
    (totalAudience && totalAudience.audience ? totalAudience.audience : 0);
};

// Function to get the amount of audience for relation
export function getAmountAudience (audience, relationId, isImpacts = false) {
  if (!audience || !audience.displays_with_audience) return 0;

  const amountAudience = audience.displays_with_audience.find(element =>
    element.relation_id === relationId
  );

  return isImpacts ? (amountAudience && amountAudience.impacts ? amountAudience.impacts :0 ) :
    (amountAudience && amountAudience.audience ? amountAudience.audience : 0);
};

const gcd = (a, b) => {
  a = Number(a)
  b = Number(b)
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 0
  return b === 0 ? a : gcd(b, a % b)
}

export function updatePriceCartByDiscountDisplay(displays, date_from, date_to, updatePriceCartByDiscountRedux){
  displays.forEach( function(display) {
    if(display.rank_discounts == undefined || (display.rank_discounts && display.rank_discounts.length < 1))
      return

    let diffDay = moment(date_to).diff(date_from, "days") + 1;
    let actualDiscount= 0
    display.rank_discounts.forEach( function(discount) {
      if(diffDay >= discount.min_range)
        actualDiscount = discount.discount
    })
    let price_calculate = display.base_price_per_day ? display.base_price_per_day : display.price_per_day
    let price = price_calculate - ((price_calculate * actualDiscount)/100)
    if(price != display.price_per_day){
      updatePriceCartByDiscountRedux(display.id, price)
    }
  })
}

export function belongsToBundle (display, listBundle) {
    // Check if the display has bundles of campaign
    if (!display.bundles || !listBundle) return;

    if (display.bundles.length > 0 && listBundle.length > 0){
      let matchBundle = display.bundles.filter(bundle => listBundle.includes(bundle.id));
      if (matchBundle.length > 0){
        return matchBundle;
      }
    }
    return;
}

export function truncateText(text, maxLength) {
  if (text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + '...';
}
// Companies that view Publimovil screens
export function getFilterDisplaysForContains (display, user) {
  let displayContains = display.constraints
  let filter = [
    {
     contains: "Solo agencias aprobadas por el dueño del medio",
     companies: [ 1068, 1247, 1248, 1249, 1250, 1251, 254, 805, 841, 936, 1068, 905, 383, 968, 1136, 626, 332, 1598, 1209, 1628, 1053, 1201, 1136, 1667 ],
     users: [ 628, 3970, 3971, 3486 ]
    },
  ]

  if (!filter.some(item => item.contains === displayContains)) {
    return true;
  }

  if (user && user.id ) {
    if(filter.find(item => item.contains === displayContains).users.includes(user.id)) return true;
  }

  if (user && user.company && user.company.id) {
    return filter.find(item => item.contains === displayContains).companies.includes(user.company.id);
  }

  return false;
}

export function calculateImpressions (type, relation, reportSingleData, display){
  if(type == "to_consumed"){
    let diff_promised_shows = relation.promised_shows + relation.promised_shows_subsidized
    let promisedInSingleData = reportSingleData.report ? reportSingleData.report.find(element => element.display === display.id && element.content === relation.content.id) : null
    return ((diff_promised_shows) - (promisedInSingleData ? promisedInSingleData.shows : 0))
  }
  if(type == "to_consumed_not_subsidized"){
    const promisedInSingleData = reportSingleData.report ? reportSingleData.report.find(element => element.display === display.id && element.content === relation.content.id) : null
    const totalConsumed = promisedInSingleData ? promisedInSingleData.shows : 0;
    const total = relation.promised_shows + (relation.promised_shows_subsidized || 0);
    const consumedPaid = total > 0 ? Math.floor(totalConsumed * relation.promised_shows / total) : 0;
    return relation.promised_shows - consumedPaid;
  }
  if (type == "to_consumed_subsidized") {
    const promisedInSingleData = reportSingleData.report ? reportSingleData.report.find(element => element.display === display.id && element.content === relation.content.id) : null
    if (!promisedInSingleData) return relation.promised_shows_subsidized || 0;
    const total = relation.promised_shows + (relation.promised_shows_subsidized || 0);
    if (total === 0) return 0;
    const consumedPaid = Math.floor(promisedInSingleData.shows * relation.promised_shows / total);
    const consumedSubsidized = promisedInSingleData.shows - consumedPaid;
    return Math.max(0, (relation.promised_shows_subsidized || 0) - consumedSubsidized);
  }
}


// Check if the display is part of a bundle
export function checkIfBundle(displayBundles, listBundle) {
  let count = 0;
  for (const bundle of displayBundles) {
    if (listBundle && listBundle.includes(bundle.id)) {
      count++;
    }
  }
  return count;
};

export function  getRelationShowDays(fromDate, toDate, rules) {
  var fromDateOnlyDate = moment(fromDate).format('YYYY-MM-DD');
  var toDateOnlyDate = moment(toDate).format('YYYY-MM-DD');
  var days;
  var listDays = [];
  // If there is rules, evaluate wich days the content has to be shown
  if (!!rules && (rules.length > 0)) {
    var daysToShow = 0;
      // Iterate over all dates between fromDate and toDate
      // Eval all rules and conditions to check if content will be shown this date
      rules.forEach(function(rule){
        rule.conditions.forEach(function(condition){
          if (condition.type === 'date') {
            fromDateOnlyDate = moment(condition.from_date).format('YYYY-MM-DD');
            toDateOnlyDate = moment(condition.to_date).format('YYYY-MM-DD');
          }
        });
        for (var dateToEval = moment(fromDateOnlyDate); moment(toDateOnlyDate).diff(dateToEval, 'days') >= 0; dateToEval.add(1, 'days')) {
            var conditionsResult = true;
            if (!!rule.conditions && Array.isArray(rule.conditions)) {
              rule.conditions.forEach(function(condition){
                if (condition.type === 'day') {
                  // If actual day is not in array, set conditionsResult as false
                  // check if you do not have any day selected
                  if(!(listDays.indexOf(dateToEval.format('YYYY-MM-DD')) == -1)){
                    conditionsResult = false;
                  }else{
                    if (condition.value.indexOf(dateToEval.day()) == -1 ) {
                      conditionsResult = false;
                    }
                  }
                }
              });
            }
            if (conditionsResult === true) {
              listDays.push(dateToEval.format('YYYY-MM-DD')) // Save day counted because repeatwhen have more rules
              daysToShow++;
            }
        }
      });
    days = daysToShow
  } else { // If there is no rules, shows per day is promised shows divided total days of campaign
    days = (moment(toDateOnlyDate).diff(moment(fromDateOnlyDate), 'days')+1)
  }

  return days
};

export const displayIsCircuit = (display) => {
  return display.count_secondary_displays > 1
}

export const circuitHasMultipleFaces = (secondaryDisplays) => {
  return secondaryDisplays && secondaryDisplays.filter(display => display.mirror_screens_count > 1).length > 0
}

export const displayIsMultipleFaces = (display) => {
  return display.count_secondary_displays > 0 ? false : display.mirror_screens_count > 1
}

export const getMultipleFacesCountInCircuit = (secondaryDisplays) => {
  return secondaryDisplays.filter(display => display.mirror_screens_count > 1).length
}

export const getTotalMultipleFacesInCircuit = (secondaryDisplays) => {
  return secondaryDisplays.reduce((acc, display) => acc + (display.mirror_screens_count > 1 ? display.mirror_screens_count : 0), 0)
}

const MINUTES_PER_DAY = 1440;

/**
 * Minimum playouts a traditional campaign is guaranteed on a screen.
 *
 * `shows_per_hour` is one playout per loop (3600 / (slots * slot_length)), so the
 * total is just that rate applied to every hour the screen is lit inside the
 * campaign dates. Weighting by day of week matters: a screen lit 13.5h on
 * weekdays and 10h on Sundays delivers ~7% less than a flat "typical day" guess.
 *
 * Rules are not considered because traditional campaigns cannot set them
 * (enabledRenderRules is programmatic-only).
 *
 * @param {Object} display - needs shows_per_hour and working_hours
 * @param {string} dateFrom
 * @param {string} dateTo
 * @returns {number} playouts for the whole period
 */
export const getMinimumPlayouts = (display, dateFrom, dateTo) => {
  const showsPerHour = Number(display && display.shows_per_hour) || 0;
  if (!showsPerHour || !dateFrom || !dateTo) return 0;

  const workingHours = display.working_hours || [];
  const minutesByDayOfWeek = {};
  workingHours.forEach((slot) => {
    let minutes = moment(slot.end_time, "HH:mm:ss").diff(moment(slot.start_time, "HH:mm:ss"), "minutes");
    // Wraps past midnight, e.g. 23:00 to 01:00.
    if (minutes < 0) minutes += MINUTES_PER_DAY;
    minutesByDayOfWeek[slot.day_of_week] = (minutesByDayOfWeek[slot.day_of_week] || 0) + minutes;
  });

  let totalMinutes = 0;
  const lastDay = moment(dateTo).startOf("day");
  for (let day = moment(dateFrom).startOf("day"); lastDay.diff(day, "days") >= 0; day.add(1, "days")) {
    // No working_hours at all means the screen is never off.
    totalMinutes += workingHours.length ? (minutesByDayOfWeek[day.day()] || 0) : MINUTES_PER_DAY;
  }

  return Math.round((showsPerHour * totalMinutes) / 60);
};

export const getSpotsPerDay = ( relation, date_from, date_to, type ) => {
  const impressionsPerDay = getRelationShowDays(date_from, date_to, relation.rules);
  if (impressionsPerDay === 0) return 0;
  const impressions = type === "subsidized" ? relation.promised_shows_subsidized : relation.promised_shows;
  return Math.round( impressions / impressionsPerDay );
};

/**
 * @param {Object} relation - customContent (promised_shows en SALIDAS)
 * @param {string} date_from
 * @param {string} date_to
 * @param {number} multiplier - de getMultiplyByStatus
 * @param {string} [type] - "subsidized" para las salidas subsidiadas
 * @returns {number} impresiones por día
 */
export const getImpressionsPerDay = ( relation, date_from, date_to, multiplier, type ) => {
  const days = getRelationShowDays(date_from, date_to, relation.rules);
  if (days === 0) return 0;
  const promisedShows = type === "subsidized"
    ? (relation.promised_shows_subsidized || 0)
    : (relation.promised_shows || 0);;
  return Math.round( (promisedShows * multiplier) / days );
};

export const getDisplayDiscounts = (display) => {
  const discounts = display.extra_info_programmatic_prices && display.extra_info_programmatic_prices.programmatic_volume_discounts;

  if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
    return null;
  }

  return discounts;
}


export const isTotalDiscount = (discount) =>
  !!discount && discount.discount_type === 'total';

/**
 * Determines whether a volume discount is unlocked for the given spots.
 * - "daily": spotsPerDay >= min_impressions
 * - "total":  totalSpots >= min_impressions
 *
 * `totalSpots` must be the real campaign total (sum of promised_shows), NOT
 * reconstructed from spotsPerDay * days — getSpotsPerDay rounds, which would
 * inflate small totals (e.g. 15 promised over 30 days → round(0.5)*30 = 30).
 *
 * @param {Object} discount - A volume discount object
 * @param {number} spotsPerDay - Spots per day (used for "daily")
 * @param {number} totalSpots - Real total campaign spots (used for "total")
 * @returns {boolean}
 */
export const isDiscountUnlocked = (discount, spotsPerDay, totalSpots) => {
  if (!discount || !discount.min_impressions) return false;
  if (isTotalDiscount(discount)) {
    return (totalSpots || 0) >= discount.min_impressions;
  }
  return spotsPerDay >= discount.min_impressions;
};

/**
 * Returns the minimum spots floor a display must keep to preserve the discount,
 * always expressed in TOTAL campaign spots.
 * - "daily": min_impressions * campaignDays
 * - "total": min_impressions (already a total)
 *
 * @param {Object} discount - A volume discount object
 * @param {number} campaignDays - Number of days the campaign runs
 * @returns {number} - Total-spots floor
 */
export const getDiscountFloorSpots = (discount, campaignDays) => {
  if (!discount || !discount.min_impressions) return 0;
  if (isTotalDiscount(discount)) return discount.min_impressions;
  return Math.ceil(discount.min_impressions * (campaignDays || 0));
};

export const getAppliedVolumeDiscount = (display, totalSpotsPerDay = null, totalSpots = null) => {
  const discounts = getDisplayDiscounts(display);

  if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
    return null;
  }

  // Use totalSpotsPerDay if provided (for display-level discount), otherwise calculate from relation
  const spotsPerDay = totalSpotsPerDay 

  // Find applicable discounts, honoring discount_type ("daily" vs "total")
  const applicableDiscounts = discounts.filter(
    discount => isDiscountUnlocked(discount, spotsPerDay, totalSpots)
  );

  if (applicableDiscounts.length === 0) {
    return null;
  }

  // Return the discount with the highest min_impressions (best applicable discount)
  return applicableDiscounts.reduce((best, current) =>
    current.min_impressions > best.min_impressions ? current : best
  );
}

/**
 * Gets the applied volume discount for a display based on total spots per day from all relations.
 * 
 * @param {Object} display - The display object
 * @param {Array} relations - All relations (content_displays) for this display
 * @param {string} date_from - Campaign start date
 * @param {string} date_to - Campaign end date
 * @returns {Object|null} - The applicable discount or null
 */
export const getAppliedVolumeDiscountByDisplay = (display, relations, date_from, date_to) => {
  const discounts = getDisplayDiscounts(display);

  if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
    return null;
  }

  // Calculate total spots per day from all relations of this display
  const totalSpotsPerDay = relations.reduce((total, relation) => {
    return total + getSpotsPerDay(relation, date_from, date_to);
  }, 0);

  // Real campaign total (sum of promised_shows) for "total" discount thresholds
  const totalSpots = relations.reduce(
    (total, relation) => total + (relation.promised_shows || 0),
    0
  );

  // Find applicable discounts, honoring discount_type ("daily" vs "total")
  const applicableDiscounts = discounts.filter(
    discount => isDiscountUnlocked(discount, totalSpotsPerDay, totalSpots)
  );

  if (applicableDiscounts.length === 0) {
    return null;
  }

  // Return the discount with the highest min_impressions (best applicable discount)
  return applicableDiscounts.reduce((best, current) =>
    current.min_impressions > best.min_impressions ? current : best
  );
}

/**
 * Calculates bonus spots per day given by volume discount.
 * With the same investment, more spots are obtained due to the discounted CPM.
 * 
 * Formula: 
 * - Original spots per day = promised_shows / days
 * - Investment = original_spots_per_day * (originalCpm / 1000)
 * - Total spots per day with discount = Investment / (discountedCpm / 1000)
 * - Bonus spots per day = total_spots_per_day - original_spots_per_day
 * 
 * @param {Object} display - The display object containing CPM and discount info
 * @param {Object} relation - The relation object with promised_shows
 * @param {string} date_from - Campaign start date
 * @param {string} date_to - Campaign end date
 * @param {number} originalCpm - The original CPM before discount
 * @param {Object} discountApplied - The discount already applied to the campaign (when editing)
 * @param {number} displayTotalSpotsPerDay - Optional total spots per day for display-level discount calculation
 * @returns {number} - Bonus spots per day, or 0 if no discount applies
 */
export const getBonusSpotsPerDay = (display, relation, date_from, date_to, originalCpm, displayTotalSpotsPerDay = null, totalSpots = null) => {
  const discount = getAppliedVolumeDiscount(display, displayTotalSpotsPerDay, totalSpots);
  
  if (!discount || !discount.final_cpm || !originalCpm || originalCpm <= 0) {
    return 0;
  }

  // If editing a campaign with an already applied discount
  // if (discountApplied && discountApplied.min_impressions) {
  //   // Only show bonus spots if the new discount range is higher
  //   if (discount.final_cpm === discountApplied.final_cpm) {
  //     return 0;
  //   }
  // }

  // Use display total spots if provided, otherwise use relation spots
  const originalSpotsPerDay = displayTotalSpotsPerDay !== null ? displayTotalSpotsPerDay : getSpotsPerDay(relation, date_from, date_to);
  
  if (originalSpotsPerDay === 0) {
    return 0;
  }

  // Calculate daily investment based on original CPM
  const dailyInvestment = originalSpotsPerDay * (originalCpm / 1000);
  
  // Calculate total spots per day with discounted CPM
  const discountedCpm = discount.final_cpm;
  const totalSpotsPerDayWithDiscount = dailyInvestment / (discountedCpm / 1000);
  
  // Bonus spots are the difference
  return Math.round(totalSpotsPerDayWithDiscount - originalSpotsPerDay);
}

/**
 * Calculates total bonus spots given by volume discount.
 * 
 * @param {Object} display - The display object containing CPM and discount info
 * @param {Object} relation - The relation object with promised_shows
 * @param {string} date_from - Campaign start date
 * @param {string} date_to - Campaign end date
 * @param {number} originalCpm - The original CPM before discount
 * @param {Object} discountApplied - The discount already applied to the campaign (when editing)
 * @param {number} displayTotalSpotsPerDay - Optional total spots per day for display-level discount calculation
 * @returns {number} - Total bonus spots, or 0 if no discount applies
 */
export const getTotalBonusSpots = (display, relation, date_from, date_to, originalCpm, displayTotalSpotsPerDay = null, totalSpots = null) => {
  const days = getRelationShowDays(date_from, date_to, relation.rules);
  const bonusSpotsPerDay = getBonusSpotsPerDay(display, relation, date_from, date_to, originalCpm, displayTotalSpotsPerDay, totalSpots);

  if (bonusSpotsPerDay === 0) {
    return 0;
  }

  return Math.round(bonusSpotsPerDay * days);
}

/**
 * Builds the `content_displays` payload for the audience endpoint: every relation with its
 * real promised_shows plus the volume-discount bonus spots it earns.
 *
 * Single source of truth so every step of the campaign editor asks the audience API for the
 * same spots (steps 0/1 used to send the budget split equally across the cart, which does not
 * match the campaign's real per-screen distribution).
 *
 * @param {Array} customContents - Campaign relations (content_displays)
 * @param {Array} cart - Displays in the cart
 * @param {string} date_from - Campaign start date
 * @param {string} date_to - Campaign end date
 * @param {boolean} editCampaignActive - Whether an existing campaign is being edited
 * @param {Object} currentCampaign - The campaign being edited
 * @returns {Array} - customContents with promised_shows including bonus spots
 */
export const buildAudienceContentDisplays = (
  customContents,
  cart,
  date_from,
  date_to,
  editCampaignActive,
  currentCampaign
) => {
  if (!customContents || customContents.length === 0) return [];

  const bonusByDisplay = {};
  [...new Set(customContents.map(content => content.displayId))].forEach(displayId => {
    const display = cart && cart.find(d => d.id === displayId);
    if (!display) return;
    const relations = customContents.filter(content => content.displayId === displayId);
    const originalCpm = getCpmByStatusCampaign(editCampaignActive, currentCampaign, display);
    const totalSpotsPerDay = relations.reduce(
      (sum, relation) => sum + getSpotsPerDay(relation, date_from, date_to),
      0
    );
    const totalPromisedShows = relations.reduce(
      (sum, relation) => sum + (relation.promised_shows || 0),
      0
    );
    if (totalSpotsPerDay > 0) {
      bonusByDisplay[displayId] = {
        total: getTotalBonusSpots(
          display,
          relations[0],
          date_from,
          date_to,
          originalCpm,
          totalSpotsPerDay,
          totalPromisedShows
        ),
        totalSpotsPerDay
      };
    }
  });

  return customContents.map(content => {
    const info = bonusByDisplay[content.displayId];
    let bonus = 0;
    if (info && info.total > 0 && info.totalSpotsPerDay > 0) {
      bonus = Math.round(
        info.total * (getSpotsPerDay(content, date_from, date_to) / info.totalSpotsPerDay)
      );
    }
    return { ...content, promised_shows: (content.promised_shows || 0) + bonus };
  });
};

/**
 * Aggregates buildAudienceContentDisplays per display, for the `displays` shape of the
 * audience endpoint.
 *
 * @returns {Array} - [{ id, promised_shows }] for every display in the cart
 */
export const buildAudienceDisplays = (
  customContents,
  cart,
  date_from,
  date_to,
  editCampaignActive,
  currentCampaign
) => {
  const contents = buildAudienceContentDisplays(
    customContents,
    cart,
    date_from,
    date_to,
    editCampaignActive,
    currentCampaign
  );
  // No relations yet (screens just added to the cart): let the API estimate the shows
  if (contents.length === 0)
    return (cart || []).map(display => ({ id: display.id, promised_shows: null }));
  const showsByDisplay = contents.reduce((acc, content) => {
    acc[content.displayId] = (acc[content.displayId] || 0) + (content.promised_shows || 0);
    return acc;
  }, {});
  return (cart || []).map(display => ({
    id: display.id,
    promised_shows: showsByDisplay[display.id] || 0
  }));
};

/**
 * Calculates bonus impacts given by volume discount.
 * With the same investment, more impacts are obtained due to the discounted CPMI.
 * 
 * Formula similar to bonus spots but using CPMI instead of CPM
 * 
 * @param {Object} display - The display object containing CPMI and discount info
 * @param {number} totalImpacts - The original total impacts
 * @param {number} originalCpmi - The original CPMI before discount
 * @param {number} totalSpotsPerDay - Optional total spots per day for display-level discount calculation
 * @returns {number} - Bonus impacts, or 0 if no discount applies
 */
export const getBonusImpacts = (display, totalImpacts, originalCpmi, totalSpotsPerDay = null, totalSpots = null) => {
  const discount = getAppliedVolumeDiscount(display, totalSpotsPerDay, totalSpots);
  
  if (!discount || !discount.final_cpmi || !originalCpmi || originalCpmi <= 0 || !totalImpacts || totalImpacts <= 0) {
    return 0;
  }
  // Calculate investment based on original CPMI
  const investment = totalImpacts * (originalCpmi / 1000);
  
  // Calculate total impacts with discounted CPMI
  const discountedCpmi = discount.final_cpmi;
  const totalImpactsWithDiscount = Math.round(investment / (discountedCpmi / 1000));
  
  // Bonus impacts are the difference
  return totalImpactsWithDiscount - totalImpacts;
}

/**
 * Gets the total impacts including bonus from volume discount.
 * 
 * @param {Object} display - The display object
 * @param {number} totalImpacts - The original total impacts
 * @param {number} originalCpmi - The original CPMI before discount
 * @param {number} totalSpotsPerDay - Optional total spots per day for display-level discount calculation
 * @returns {number} - Total impacts with discount applied
 */
export const getTotalImpactsWithDiscount = (display, totalImpacts, originalCpmi, totalSpotsPerDay = null, totalSpots = null) => {
  const bonusImpacts = getBonusImpacts(display, totalImpacts, originalCpmi, totalSpotsPerDay, totalSpots);
  return totalImpacts + bonusImpacts;
}

/**
 * Calculates the maximum extractable spots from a display without losing the applied discount.
 * 
 * Formula: maxExtractable = (totalSpotsPerDay - appliedDiscount.min_impressions) * relationShowDays
 * 
 * @param {number} totalSpots - Total current spots for the display
 * @param {number} totalSpotsPerDay - Total spots per day for the display
 * @param {Object} appliedDiscount - The applied volume discount (must have min_impressions)
 * @param {number} relationShowDays - Number of days the campaign runs
 * @returns {number} - Maximum spots that can be extracted without losing the discount
 */
export const getMaxExtractableSpots = (totalSpots, totalSpotsPerDay, appliedDiscount, relationShowDays) => {
  if (!appliedDiscount || !appliedDiscount.min_impressions || relationShowDays <= 0) {
    return totalSpots;
  }

  // Total-spots floor honoring discount_type ("daily" → min * days, "total" → min)
  const minTotalSpots = getDiscountFloorSpots(appliedDiscount, relationShowDays);
  const maxExtractable = Math.floor(totalSpots - minTotalSpots);

  return Math.max(0, Math.min(maxExtractable, totalSpots));
}